<template>
  <span class="error--text">{{ $t(`formatters.errorcode.code.${code}`) }}</span>
</template>

<script>
  export default {
    props: {
      code: {
        type: [String, Number],
        required: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/formatters/ErrorCode.vue